<template>
	<editor-popover
			:style="{ top: positionY + 'px', left: positionX + 'px', maxHeight: previewHeight + 'px' }"
			:type="'sentence-previewer'"
			class="sentence-preview-popover right-overload"
			ref="popover"
			v-show="previewingSentence"
	>
		<sentence-preview-arrow
				:style="{top: posArrowY + 'px', left: posArrowX + 'px' }"
		/>
		<template v-if="templateSection">
			<sentence-preview
					:depth="0"
					:highlight-path="pathToHighlight"
					:key="index"
					:path="[index]"
					:sentence="s"
					v-for="(s, index) in templateSection"
			/>
		</template>
	</editor-popover>
</template>

<script>
	import EditorPopover from '@/components/EditorPopover'
	import SentencePreview from '@/components/SentencePreview'
	import SentencePreviewArrow from '@/components/SentencePreviewArrow'
	import EventBus from '@/assets/js/eventBus.js'

	export default {
		name: 'SentencePreviewPopover',
		props: {
			template: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				positionX: null,
				positionY: null,
				posArrowX: null,
				posArrowY: null,
				previewHeight: null,
				previewingSentence: null,
				previewingElement: null,
				templateSection: null,
				stopPreviewRequested: false,
				pendingSentenceToPreview: null,
				pathToHighlight: null,
				config: {}
			}
		},
		watch: {
			sentenceBeingEdited(sentence) {
				this.$store.commit('setSentenceBeingEdited', sentence)
				if (sentence && this.previewingSentence) this.stop()
			}
		},
		computed: {
			sentenceBeingEdited() {
				return this.$store.state.sentenceBeingEdited
			},
			templateBranch() {
				if (!this.previewingSentence) return null
				let path = this.previewingSentence.path
				return this.templateSection[path[0]]
			}
		},
		methods: {
			blockPopover() {
				this.$store.commit('blockSentencePreviewPopover')
			},
			unblockPopover() {
				this.$store.commit('unblockSentencePreviewPopover')
			},
			mousePosition(posX, posY) {
				let editorWidth = document.querySelector('#editorContent').offsetWidth
				let popoverHeight = document.querySelector('#editorContent').offsetHeight

				if ((posX + 300) > editorWidth) {
					this.positionX = editorWidth - 620
				} else if (posX < 400) {
					this.positionX = 100
				} else {
					this.positionX = posX - 300
				}

				this.positionY = posY
				this.previewHeight = popoverHeight - posY

				this.posArrowX = posX
				this.posArrowY = posY + 3
			},
			start(sentence, element, section) {
				this.previewingSentence = sentence
				this.templateSection = this.template[section]
				this.pathToHighlight = sentence.path
				let shouldntStart = !element || !this.$refs.popover || !sentence || !section
				if (shouldntStart) {
					return;
				}
				this.previewingElement = element
				this.previewingElement.classList.add('previewing')
				this.previewingElement.appendChild(this.$refs.popover.$el)
			},
			stop() {
				this.pendingSentenceToPreview = null
				this.previewingSentence = null
				this.templateSection = null
				if (this.previewingElement) {
					this.previewingElement.classList.remove('previewing')
					this.previewingElement = null
				}
				if (this.$refs.popover.$el && this.$refs.popover.$el.classList) {
					// console.log(`popover from refs: ${JSON.stringify(this.$refs.popover.$el.classList, null, 2)}`)
					this.$refs.popover.$el.classList.remove('right-overload')
				}
			},
			onStartPreviewingSentence({sentence, element, section, posX, posY}) {
				// the user started hovering a sentence -> start previewing if the user continues to hover the sentence
				let popoverBlocked = this.$store.state.sentencePreviewPopoverIsBlocked
				if (popoverBlocked || this.sentenceBeingEdited) return // previewing not allowed when also editing a sentence
				this.stopPreviewRequested = false // cancel any requests to stop previewing
				if (this.pendingSentenceToPreview === sentence) return // no need to continue if already previewing this sentence
				this.pendingSentenceToPreview = sentence // save the sentence for later reference
				// wait a bit before checking if user is still hovering the same sentence
				window.setTimeout((() => {
					if (sentence === this.pendingSentenceToPreview) {
						if (this.previewingSentence && this.previewingSentence !== sentence) this.stop() // stop any current previews before starting
						if (this.sentenceBeingEdited) this.stop()
						this.mousePosition(posX, posY)
						this.start(sentence, element, section)
					}
				}).bind(this), 777)
			},
			onStopPreviewingSentence() {
				// the user stopped hovering the sentence to preview -> stop previewing after confirming that it was intentional.
				if (!this.previewingSentence) return // no need to continue if we're not previewing anything
				this.stopPreviewRequested = true // make a note that we're stopping the preview in a bit
				this.pendingSentenceToPreview = null // in case we're pending another preview, cancel that.
				setTimeout((() => {
					if (this.stopPreviewRequested && this.previewingSentence) {
						// the stop has not been cancelled -> stop previewing
						this.stop()
					}
				}).bind(this), 333)
			}
		},
		components: {
			SentencePreview,
			EditorPopover,
			SentencePreviewArrow
		},
		created() {
			this.$set(this.$store.state, 'sentencePreviewConfig', this.config)
			EventBus.$on('previewSentence', this.onStartPreviewingSentence)
			EventBus.$on('stopPreviewingSentence', this.onStopPreviewingSentence)
			EventBus.$on('selectedTextDidChange', this.blockPopover)
			EventBus.$on('editorDidLoseFocus', this.unblockPopover)
		}
	}
</script>

<style lang="less" scoped>
	.top-gutter {
		position: absolute;
		top: -10px;
		left: 0;
		width: 100%;
		height: 10px;
		background-color: red;
	}

	.sentence-preview-popover {
		position: fixed;
		top: 100%;
		left: 0;
		margin-top: 10px;
		// margin: 0 15px;
		// position: static !important;

		padding: 20px;
		background-color: #3d464a;
		z-index: 99;
		width: 600px;
		// min-width: 450px;
		// max-width: 800px;
		color: #fff;
		font-size: 14px;
		cursor: default;
		overflow-y: auto;

		&:before {
			content: '';
			height: 10px;
			width: 100%;
			position: absolute;
			background: red;
			top: -10px;
			left: 0;
			display: block;
		}

		* {
			// pointer-events: none;

			tab-size: 0;
		}
	}

	.sentence-preview-popover.right-overload {
		left: auto;
		right: 20px;
	}
</style>

